/**
 * cart-shipping-notice.js — Jewels Park Wholesale
 * Shows shipping progress bar in cart drawer AND cart page.
 * $70 shipping under $1,000 · Free shipping at $1,000+
 *
 * INSTALL:
 *   Assets → cart-shipping-notice.js → paste → Save
 *   layout/theme.liquid → before </body>:
 *   <script src="{{ 'cart-shipping-notice.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  const THRESHOLD = 100000; // $1,000 in cents
  const SHIPPING  = 70;     // flat shipping in dollars

  const CSS = `
    .jp-ship-bar {
      margin: 12px 16px 0;
      padding: 12px 14px;
      background: #f9f9f9;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      font-size: 13px;
      color: #333;
    }
    .jp-ship-bar.jp-free {
      background: #f0faf4;
      border-color: #b7dfca;
    }
    .jp-ship-bar__top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      gap: 8px;
    }
    .jp-ship-bar__msg {
      line-height: 1.4;
      flex: 1;
    }
    .jp-ship-bar__msg strong { font-weight: 700; color: #111; }
    .jp-ship-bar.jp-free .jp-ship-bar__msg { color: #1a5c38; }
    .jp-ship-bar__cost {
      font-weight: 700;
      font-size: 14px;
      white-space: nowrap;
      color: #111;
    }
    .jp-ship-bar.jp-free .jp-ship-bar__cost { color: #1a5c38; }
    .jp-ship-bar__track {
      height: 5px;
      background: #e0e0e0;
      border-radius: 3px;
      overflow: hidden;
    }
    .jp-ship-bar__fill {
      height: 100%;
      background: #111;
      border-radius: 3px;
      transition: width 0.4s ease;
    }
    .jp-free .jp-ship-bar__fill { background: #2d7a4f; }
  `;

  function injectCSS() {
    if (document.getElementById('jp-ship-css')) return;
    const s = document.createElement('style');
    s.id = 'jp-ship-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function fmt(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function buildBar(totalCents) {
    const isFree   = totalCents >= THRESHOLD;
    const pct      = Math.min(100, Math.round(totalCents / THRESHOLD * 100));
    const remaining = fmt(Math.max(0, THRESHOLD - totalCents));

    const bar = document.createElement('div');
    bar.className = 'jp-ship-bar' + (isFree ? ' jp-free' : '');
    bar.id = 'jp-ship-bar';

    if (isFree) {
      bar.innerHTML = `
        <div class="jp-ship-bar__top">
          <div class="jp-ship-bar__msg">🎉 <strong>Free Shipping</strong> unlocked on your order!</div>
          <div class="jp-ship-bar__cost">$0.00</div>
        </div>
        <div class="jp-ship-bar__track"><div class="jp-ship-bar__fill" style="width:100%"></div></div>
      `;
    } else {
      bar.innerHTML = `
        <div class="jp-ship-bar__top">
          <div class="jp-ship-bar__msg">
            Add <strong>${remaining}</strong> more for <strong>Free Shipping</strong>
          </div>
          <div class="jp-ship-bar__cost">$${SHIPPING}.00</div>
        </div>
        <div class="jp-ship-bar__track">
          <div class="jp-ship-bar__fill" style="width:${pct}%"></div>
        </div>
      `;
    }
    return bar;
  }

  // ── Find the best injection point ────────────────────────────────────────────
  function getTarget() {
    const candidates = [
      '.m-cart__subtotal',           // confirmed from Minimog inspector
      '.m-cart__footer-subtotal',
      '.m-cart-footer__subtotal',
      '[class*="cart-subtotal"]',
      '[class*="cart__subtotal"]',
      '.m-cart__footer',
      '.m-cart-footer',
    ];
    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function render(totalCents) {
    // Remove existing bar
    document.getElementById('jp-ship-bar')?.remove();

    const target = getTarget();
    if (!target) return;

    const bar = buildBar(totalCents);
    target.insertAdjacentElement('beforebegin', bar);
  }

  async function fetchAndRender() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      render(cart.total_price);
    } catch (_) {}
  }

  // ── Watch for cart drawer opening and cart updates ────────────────────────────
  function init() {
    injectCSS();
    fetchAndRender();

    // Re-render on Minimog cart events
    document.addEventListener('cart:updated',  fetchAndRender);
    document.addEventListener('cart:refresh',  fetchAndRender);
    document.addEventListener('cart:open',     fetchAndRender);

    // Watch for drawer being added/shown in DOM
    new MutationObserver(() => {
      // Re-inject if bar is gone (drawer re-rendered)
      if (!document.getElementById('jp-ship-bar')) {
        fetchAndRender();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
